module.exports = __webpack_public_path__ + "static/media/token-usdc.057331cb.svg";